export default {
	title: 'God panel home',
	description:
		'From this panel you can keep track of organizations, projects, and the general state of the application. You are a god user, meaning you have the highest tier control of all users.',
}
